import React from 'react';

interface DashboardLogoProps {
  className?: string;
}

export function DashboardLogo({ className }: DashboardLogoProps) {
  return (
    <div className={className}>
      <picture>
        <source
          media="(prefers-color-scheme: dark)"
          srcSet="/lovable-uploads/3a2ed875-9786-495b-b632-24bada2be41f.png"
        />
        <source
          media="(prefers-color-scheme: light)"
          srcSet="/lovable-uploads/3a2ed875-9786-495b-b632-24bada2be41f.png"
        />
        <img
          src="/lovable-uploads/3a2ed875-9786-495b-b632-24bada2be41f.png"
          alt="Company Logo"
          className="h-8 w-auto"
        />
      </picture>
    </div>
  );
}
